import { z } from 'zod';

import { zodTimeStamp } from '@/utils/zodUtils';

// PIN type enum.
export const PINTypeEnum = z.enum(['SUPPORT', 'SITE', 'EMERGENCY']);
export type PINTypeEnum = z.infer<typeof PINTypeEnum>;

// PIN schema (server response shape).
export const PIN = z.object({
  id: z.string(),
  location_id: z.string(),
  pin_type: PINTypeEnum,
  label: z.string().nullable().optional(),
  created_by: z.string(),
  sync_version: z.number(),
  sync_confirmed_at: zodTimeStamp.nullable().optional(),
  created_at: zodTimeStamp,
  updated_at: zodTimeStamp,
});

export type PINType = z.infer<typeof PIN>;
export const PINList = z.array(PIN);
export type PINListType = z.infer<typeof PINList>;

// Create PIN request (4-8 numeric digits).
export const CreatePINRequest = z.object({
  pin: z.string().min(4).max(8).regex(/^\d+$/),
  pin_type: PINTypeEnum,
  label: z.string().max(100).optional(),
});

export type CreatePINRequestType = z.infer<typeof CreatePINRequest>;

// Override type enum.
export const OverrideTypeEnum = z.enum(['LOCKDOWN', 'MANUAL', 'NONE']);
export type OverrideTypeEnum = z.infer<typeof OverrideTypeEnum>;

// Override state enum.
export const OverrideStateEnum = z.enum([
  'HELD_OPEN',
  'CLOSED',
  'SECURED',
  'LOCKED',
]);
export type OverrideStateEnum = z.infer<typeof OverrideStateEnum>;

// Access point lockdown override schema (server response shape).
export const AccessPointLockdownOverride = z.object({
  id: z.string(),
  access_point_id: z.string(),
  override_type: OverrideTypeEnum,
  override_state: OverrideStateEnum,
  auto_clear: z.boolean(),
  initiated_by: z.string(),
  reason: z.string().nullable(),
  created_at: zodTimeStamp,
  updated_at: zodTimeStamp,
  cleared_at: zodTimeStamp.nullable(),
});

export type AccessPointLockdownOverrideType = z.infer<
  typeof AccessPointLockdownOverride
>;

// Create lockdown override request.
export const CreateLockdownOverrideRequest = z.object({
  override_state: OverrideStateEnum,
  auto_clear: z.boolean(),
  reason: z.string().max(500).optional(),
});

export type CreateLockdownOverrideRequestType = z.infer<
  typeof CreateLockdownOverrideRequest
>;
